import React, { useState } from "react";
import { SiteImage } from "./SiteImage";

export function ImageGallery({ items, title, variant = "photo" }) {
  const [active, setActive] = useState(null);

  return (
    <>
      <div className={`image-gallery image-gallery-${variant}`} aria-label={title}>
        {items.map((item, idx) => (
          <button
            className="gallery-image-button"
            type="button"
            key={item.id || item.label || idx}
            onClick={() => (item.src ? setActive(item) : null)}
            data-testid={`gallery-button-${item.label}`}
          >
            {item.src ? (
              <SiteImage
                src={item.src}
                alt={item.alt}
                className={variant === "menu" ? "gallery-menu-photo" : ""}
                fallbackLabel="Redland Golf & Country Club"
              />
            ) : (
              <div className="gallery-fallback" role="img" aria-label={item.alt}>
                <span>Redland Golf &amp; Country Club</span>
              </div>
            )}
            <span>{item.label}</span>
          </button>
        ))}
      </div>
      {active ? (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label={active.label} data-testid="gallery-lightbox">
          <button type="button" className="lightbox-close" onClick={() => setActive(null)} data-testid="lightbox-close">
            Close
          </button>
          {active.src ? (
            <SiteImage src={active.src} alt={active.alt} className="lightbox-photo" fallbackLabel="Redland Golf & Country Club" />
          ) : null}
        </div>
      ) : null}
    </>
  );
}
